import React from 'react';
import { CartHeader } from '../cart-header';

export interface CartHeaderComponentProps {
    isMobile?: boolean;
}

export const CartHeaderComponent: React.FC<CartHeaderComponentProps> = ({ isMobile }) => {
    return <CartHeader isMobile={isMobile} />;
};
